module.exports = __webpack_public_path__ + "img/promo-1-mock.1f0b3b5c.png";